import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import { domainName, processApi } from "../../../../utility/index"
import moment from "moment";

export default {
    components: { iTable, IPagination },
    data() {
        return {
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                MaintainTime: [],
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "requestSerialNumber",
                    label: this.$t('VehicleManagement.serialNumber'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('common.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "carWorkTime",
                    label: this.$t('VehicleManagement.carWorkTime'),
                    align: "center",
                    width: "160px"

                },
                {
                    prop: "contactName",
                    label: this.$t('VehicleManagement.repairPerson'),
                    align: "center",
                    width: "120px"
                },

                {
                    prop: "happenTime",
                    label: this.$t('VehicleManagement.repairTime'),
                    align: "center",
                    width: "200px"
                },
                {
                    prop: "phone",
                    label: this.$t('VehicleManagement.phone'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "urgeCount",
                    label: this.$t('VehicleManagement.urgeCount'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "repairState",
                    label: this.$t('common.repairStatus'),
                    align: "center",
                    width: "120px",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.repairState === '' ? '' : params.row.repairState === 0 ? 'danger' : params.row.repairState === 1 ? 'warning' : params.row.repairState === 2 ? 'success' : 'info' }
                        }, params.row.repairState === '' ? '' : params.row.repairState === 0 ? this.$t('VehicleManagement.unaccepted') : params.row.repairState === 1 ? this.$t('VehicleManagement.repaired') : params.row.repairState === 2 ? this.$t('VehicleManagement.alreadyRepaired') : this.$t('VehicleManagement.closed'))
                    }

                }
            ],
            operates: {
                width: 120,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        isBtn: "REPAIRFORM_DETAIL",
                        method: (index, row) => {
                            // this.dialogDetailsFormVisible = true
                            // this.queryDetails(index, row)
                            this.$router.push({
                                path: '/VehicleManagement/RepairManagement/Details',
                                query: {requestSerialNumber: row.requestSerialNumber, tabName: 'four'}
                            })
                        }
                    }
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            orgId: '',
            selected: [],
            requestSerialNumber: ''
        }
    },
    methods: {
        getRepairList() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.MaintainTime) {
                if (this.formInline.MaintainTime.length > 0) {
                    startTime = this.formInline.MaintainTime[0]
                    endTime = this.formInline.MaintainTime[1]
                }
            }
            let param = {
                orgId: this.orgId,
                userId: sessionStorage.getItem("userId"),
                repairState: 3,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                startTime: startTime,
                endTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('RepairManagement/GET_GETREQUESTREPAIRLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getRepairList()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                MaintainTime: [],
            }
            this.getRepairList()
        },
        deleteRepair() {
            this.$confirm(this.$t('VehicleManagement.form.confirmRemind'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { requestSerialNumber: this.selected[0].requestSerialNumber }
                    this.$store.dispatch('RepairManagement/GET_UPDATEURGECOUNT', param).then(response => {
                        if (response.data.code == 200) {
                            this.getRepairList()
                            this.$message.success(this.$t('VehicleManagement.form.remindSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        down() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let startTime = ''
                    let endTime = ''
                    if (this.formInline.MaintainTime) {
                        if (this.formInline.MaintainTime.length > 0) {
                            startTime = this.formInline.MaintainTime[0]
                            endTime = this.formInline.MaintainTime[1]
                        }
                    }
                    let url = `https://${domainName}/v1/getExportExcel/exportRequestRepairList?orgId=${this.orgId}&userId=${sessionStorage.getItem("userId")}&repairState=${3}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportRequestRepairList?orgId=${this.orgId}&userId=${sessionStorage.getItem("userId")}&repairState=${3}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
            // this.requestSerialNumber = this.selected[0].requestSerialNumber
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getRepairList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}